import React, { useState } from 'react';
import { Database, Mail, LifeBuoy } from 'lucide-react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import IntegracaoFluxosSeguro from './IntegracaoFluxosSeguro';
import IntegracaoGix from './IntegracaoGix';
import IntegracaoGlpi from './IntegracaoGlpi';

interface Props {
  session: any;
}

type Aba = 'gix' | 'glpi' | 'email';

const ABAS: Array<{ id: Aba; label: string; descricao: string; icon: any }> = [
  {
    id: 'gix',
    label: 'GIX (ERP Refricril)',
    descricao: 'Criar, liberar e consultar OCs no Pyxis',
    icon: Database,
  },
  {
    id: 'glpi',
    label: 'GLPI (Helpdesk)',
    descricao: 'Importar chamados do GLPI como cards de um fluxo',
    icon: LifeBuoy,
  },
  {
    id: 'email',
    label: 'E-mails para Fluxos',
    descricao: 'Configuradores de destinos de e-mail para anexos',
    icon: Mail,
  },
];

const IntegracoesPage: React.FC<Props> = ({ session }) => {
  const [aba, setAba] = useState<Aba>('gix');

  // Verificar se usuário é administrador
  const isAdmin = ['administrator', 'admin'].includes(session?.usuario?.role);

  if (!isAdmin) {
    return (
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="text-center py-16">
          <ExclamationTriangleIcon className="h-16 w-16 text-gray-400 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Acesso Restrito</h2>
          <p className="text-gray-500">
            Apenas administradores podem gerenciar integrações.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto px-4 py-6">
      <div className="mb-5">
        <h1 className="text-2xl font-bold text-gray-900">Integrações</h1>
        <p className="text-sm text-gray-500 mt-0.5">
          Conecte o Escalone a sistemas externos. Cada integração tem seus próprios toggles
          de liga/desliga; a configuração específica de cada etapa continua dentro do fluxo.
        </p>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200 mb-5">
        <nav className="flex gap-1" role="tablist">
          {ABAS.map(item => {
            const Icon = item.icon;
            const ativo = aba === item.id;
            return (
              <button
                key={item.id}
                role="tab"
                aria-selected={ativo}
                onClick={() => setAba(item.id)}
                className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors -mb-px ${
                  ativo
                    ? 'border-indigo-600 text-indigo-700'
                    : 'border-transparent text-gray-500 hover:text-gray-800 hover:border-gray-300'
                }`}
              >
                <Icon className="w-4 h-4" />
                <span>{item.label}</span>
              </button>
            );
          })}
        </nav>
      </div>

      {/* Conteúdo */}
      <div>
        {aba === 'gix' && <IntegracaoGix session={session} />}
        {aba === 'glpi' && <IntegracaoGlpi session={session} />}
        {aba === 'email' && <IntegracaoFluxosSeguro session={session} />}
      </div>
    </div>
  );
};

export default IntegracoesPage;
